import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@honda-canada/design-system-react';
import Context from './Context';
import { useAccessories } from '../../SelectProductsContext/SelectProductsProvider';

import themeStyles from './AddToBuildButton.styles';

const BuildWrapper = themeStyles.apply(Box, 'BuildWrapper');

const BuildUIStateProvider = ({ children, isClickable, accessoryKey }) => {
  const [isOnBuild, setIsOnBuild] = useState(false);
  const { accessories, addAccessory, removeAccessory } = useAccessories();

  useEffect(() => {
    if (accessories.includes(accessoryKey)) {
      setIsOnBuild(true);
    }
  }, []);

  const toggleBuild = useCallback(
    event => {
      event?.stopPropagation();
      setIsOnBuild(prevState => !prevState);
      if (accessories.includes(accessoryKey)) {
        removeAccessory(accessoryKey);
      } else {
        addAccessory(accessoryKey);
      }
    },
    [accessories, accessoryKey],
  );

  const contextValue = useMemo(
    () => ({
      isOnBuild,
      toggleBuild,
    }),
    [isOnBuild, toggleBuild],
  );

  return (
    <Context.Provider value={contextValue}>
      <BuildWrapper isOnBuild={isOnBuild} onClick={isClickable ? toggleBuild : undefined} data-testid="cy-build-border">
        {children}
      </BuildWrapper>
    </Context.Provider>
  );
};

BuildUIStateProvider.propTypes = {
  children: PropTypes.node,
  isClickable: PropTypes.bool,
  accessoryKey: PropTypes.string,
};

export default BuildUIStateProvider;
